module.exports = __webpack_public_path__ + "img/52.9.TU.e1b6c879.png";